export default __webpack_public_path__ + "static/media/logo3.efb49237.png";